import type { TableHeadProps } from "@mui/material";
import { TableCell, TableHead, TableRow } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";

interface Props extends TableHeadProps {
  className: string;
}

export const StaticTokenTableHead = (props: Props) => {
  const { t } = useTranslation();
  return (
    <TableHead {...props}>
      <TableRow
        className={classNames(styles["table-head-row"], props.className)}
      >
        <TableCell sortDirection={"desc"}>
          {t("static_token.table_token_column")}
        </TableCell>
        <TableCell>{t("static_token.table_validation_column")}</TableCell>
        <TableCell>{t("static_token.table_actions_column")}</TableCell>
      </TableRow>
    </TableHead>
  );
};
